
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "24909d1e-a988-4361-94ab-09c64ed2a744"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/prow/go/src/github.com/bittorrent/ads-content-website/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
